import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const cyclicVoltammetry = {
    jpath: ['spectra', 'cyclicVoltammetry'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default cyclicVoltammetry;
//# sourceMappingURL=cyclicVoltammetry.js.map